module.exports = __webpack_public_path__ + "static/media/lead_followed_up_card_corner_img.279e5751.svg";